import { gql } from '@apollo/client';

export const GetMyObjectGroupsQueryName = 'GetMyObjectGroups';

export const GET_MY_OBJECT_GROUPS_QUERY = gql`
  query ${GetMyObjectGroupsQueryName} {
    getMyObjectGroups {
      id
      createdAt
      createdBy
      name
      description
      shared
      level
    }
  }
`;
